import * as React from 'react';
import {connect} from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import {ActionDetailsIcon} from 'HelperFunctions/DetailsSidebarHelpers';
import {submit} from 'redux-form';
import * as UserModule from 'Modules/UserModule';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {ParentDetails, IParentDetailsProps, CustomProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import {Types} from '../../../Models/UserModel';

interface IP extends IParentDetailsProps {
    edit: boolean;
    match?: any;
}

interface IConnectedP {
    elStore: UserModule.Types.UserStore;
}

interface IDispatchedP {
    deleteUser: (userId: number) => void;
    setActiveUser: (user: UserModule.Types.UserDto) => void;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
    t?: (key: string) => string;
    addUserFormSubmit: () => void;
    clearStatus: () => Function;
    blockUser: (userId: number) => Function;
    unblockUser: (userId: number) => Function;
}

type S = {};

class ManageUserDetails extends ParentDetails<IP & IConnectedP & IDispatchedP, S> {
    constructor(props: IP & IConnectedP & IDispatchedP) {
        super(props);
    }

    protected manageBlockClick() {
        const {activeEl, showPopup, blockUser} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (activeEl) {
            showPopup({
                type: PopupType.BLOCK_USER,
                confirmCallback: async () => {
                    await blockUser(activeEl.id);
                }
            });
        }
    }

    protected manageUnblockClick() {
        const {activeEl, showPopup, unblockUser} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (activeEl) {
            showPopup({
                type: PopupType.UNBLOCK_USER,
                confirmCallback: async () => {
                    await unblockUser(activeEl.id);
                }
            });
        }
    }

    public getCustomProps(): CustomProps {
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        const {
            elStore: {activeUser}
        } = this.props;

        return {
            ...(this.props as any),
            activeEl: activeUser,
            redirectUrlEdit: `/users-management/${activeUser ? activeUser.id : ''}`,
            redirectUrlAdd: '/users-management/add',
            popupTypeDelete: PopupType.DELETE_FLEET
            //labelAdd:this.props.t('add'),
            //labelEdit:this.props.t('edit'),
            //labelDelete:this.props.t('delete'),
            //extrnalRender:()=>this.extrnalRender()
        };
    }

    protected cancelClick() {
        const {USER_MANAGEMENT} = ViewManagementModule.EnumTypes.Page;
        this.props.setActiveUser(null);
        this.props.clearStatus();
        this.props.history.push(`${Dictionary.PageUrl.get(USER_MANAGEMENT)}`);
    }

    public render() {
        const {t} = this.props;
        const {
            elStore: {activeUser}
        } = this.props;

        return (
            <div className="details-right__dashboard">
                <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:save')} e2eId={"saveBtn"}
                                   onClick={() => this.props.addUserFormSubmit()}/>
                {/* {this.props.match.params.userId !== 'add' && <ActionDetailsIcon active={true} iconSrc={`/images/icons/garbage.svg`} title={t('delete')} onClick={() => this.manageDeleteClick()} />} */}
                <ActionDetailsIcon active iconSrc={`/images/icons/red_cros.svg`} title={t('forms:cancel')}
                                   e2eId={"cancelBtn"} onClick={() => this.cancelClick()}/>
                {activeUser && activeUser.status == UserModule.UserEnumTypes.Status.BLOCKED ? (
                    <div
                        className={`details-right__dashboard-item ${activeUser ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => this.manageUnblockClick()}>
                        <img src={`/images/icons/block_active.svg`} alt="" className="details-right__dashboard-icon"/>
                        <span>{t('tables:unblockUser')}</span>
                    </div>
                ) : (
                    <div
                        className={`details-right__dashboard-item ${activeUser ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => this.manageBlockClick()}>
                        <img src={`/images/icons/block_active.svg`} alt="" className="details-right__dashboard-icon"/>
                        <span>{t('tables:blockUser')}</span>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: RootState): IConnectedP {
    return {
        elStore: state.userStore
    };
}

function mapDispachToProps(dispatch: any): IDispatchedP {
    return {
        deleteUser: userId => dispatch(UserModule.Actions.deleteUser(userId)),
        setActiveUser: (user: UserModule.Types.UserDto) => dispatch(UserModule.Actions.setActiveUser(user)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        addUserFormSubmit: () => dispatch(submit('addUserForm')),
        clearStatus: () => dispatch(UserModule.Actions.clearCreateUserStatus()),
        blockUser: (userId: number) => dispatch(UserModule.Actions.blockUser(userId)),
        unblockUser: (userId: number) => dispatch(UserModule.Actions.unblockUser(userId))
    };
}

export default withTranslation(['carDetails', 'forms'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ManageUserDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ManageUserDetails.tsx